import React from 'react';
import styles from './css/index.module.css';

/** Lightweight avatar — do not import CustomAvatar from TaskManagement (pulls that whole module). */
const TentAvatar = ({ name, size = 16, color = '#003048', margin = 'auto' }) => {
    const getInitials = fullName => {
        if (!fullName) return '';
        const names = String(fullName).trim().split(/\s+/);
        if (names.length >= 2) {
            return `${names[0][0] || ''}${names[1][0] || ''}`.toUpperCase();
        }
        return (fullName[0] || '').toUpperCase();
    };

    return (
        <div
            className={styles.tentAvatar}
            style={{
                width: size,
                height: size,
                backgroundColor: color,
                fontSize: Math.max(9, Math.round(size * 0.3)),
                margin: margin || 'auto',
            }}
            title={name}
        >
            {getInitials(name)}
        </div>
    );
};

export default TentAvatar;
